import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { StudentsReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { StudentsReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class StudentsReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getStudentsReport(filter: StudentsReportFilterForm): Observable<DataWithPagination<StudentsReport[]>> {
    return this.baseAPI.post(Constants.GET_STUDENTS_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<StudentsReport[]> = {
          data: this.mapper.fromListJson(StudentsReport, res.students),
          count: res.count,
        };
        return data;
      })
    );
  }
}
